export class DeleteFleetDefinitionResponse {
    fleetId?: string;
}